import { useQuery } from "@tanstack/react-query";
import type { fluidPay } from "../types";
import { useFluidPayApi } from "../context";
import { FLUID_PAY_QUERY_KEYS } from "../query-keys";

interface UseCustomerAddressesResult {
  addresses: fluidPay.CustomerAddress[];
  isLoading: boolean;
  error: Error | null;
  refetch: () => void;
}

export function useCustomerAddresses(
  customerId: number | undefined,
  jwt: string | undefined,
): UseCustomerAddressesResult {
  const api = useFluidPayApi();
  const hasValidJwt = !!jwt && jwt.trim().length > 0;

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: FLUID_PAY_QUERY_KEYS.addresses(customerId!),
    queryFn: async () => api.addresses.fetchAll(jwt!),
    enabled: hasValidJwt && !!customerId,
    retry: false,
    staleTime: 30000,
  });

  return {
    addresses: data?.addresses || [],
    isLoading: hasValidJwt ? isLoading : false,
    error: error as Error | null,
    refetch,
  };
}
